import moment from 'moment';

export function formatUnixTimestamp(
  date?: number | string | null,
  format: string | undefined = 'DD.MM.YYYY, h:mm A'
): string | null {
  if (!date) return null;

  date = parseInt(date.toString(), 10);

  if (!moment(date * 1000).isValid()) return null;

  return moment(date * 1000).format(format);
}
